import {isNil} from 'ramda';
import {isNilOrEmpty, isFalse} from 'ramda-adjunct';

import {GetReceiveNoteFastTrackResponse} from '@dms/api/warehouse';

export const isReceiveNoteFastTracksPending = (
  receiveNoteFastTracks: GetReceiveNoteFastTrackResponse | undefined
): boolean => {
  if (isNil(receiveNoteFastTracks) || isNilOrEmpty(receiveNoteFastTracks?.receiveNoteItems)) {
    return false;
  }

  return receiveNoteFastTracks?.receiveNoteItems.some((receiveNoteItem) =>
    isFalse(receiveNoteItem.isAccepted)
  );
};
